export const GET_BUILDINGS = 'GET_BUILDINGS';
export const IPURE_HOST = 'https://ipure.nfit.au.dk/';
export const T3_HOST = `${IPURE_HOST}web/xmltojson.php`;
export const T3_DEFAULT_PARAMS = '?getdepartments=false&getoverlays=false';
export const IPURE_DETAILS = 'current/da_DK/lno/';
export const IPURE_SEARCH_PEOPLE = 'searchPeople.php';
export const IPURE_SEARCH_BUILDINGS = 'searchBuildings.php';
export const IPURE_SEARCH_DEPARTMENTS = 'searchDepartments.php';
export const IPURE_RESULTS = 'results.php?mode=json';
